/**
 * Registers a minimal pass-through SW so `beforeinstallprompt` can fire when the browser’s
 * installability checks pass (HTTPS or localhost; not plain http://LAN-IP in Chromium).
 */
export function registerPwaServiceWorker(): void {
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) return

  const pub = (process.env.PUBLIC_URL || '').replace(/\/$/, '')
  const swPath = `${pub}/sw.js`
  const scope = pub ? `${pub}/` : '/'

  window.addEventListener('load', () => {
    void navigator.serviceWorker.register(swPath, { scope }).catch(() => {
      /* Dev-server quirks or blocked SW — install may still work via browser menu on some builds */
    })
  })
}
